import http from '@/api/http'
import { diseasesPageLimit } from '@/config/api'
import { cursorParams, type PageMeta } from '@/api/pagination'

export interface Disease {
  // One row from GET `/diseases` (cursor-paginated list).

  id: number
  // Disease record id.

  person_id: string
  // UUID of the person (client) this sick-leave record applies to; resolve via POST `/persons/clients/by-ids` for display.

  from_date: string
  // ISO 8601 datetime (midnight-UTC) when the sick-leave starts.

  to_date: string
  // ISO 8601 datetime (midnight-UTC) when the sick-leave ends (inclusive per backend contract).

  notes: string
  // Free-form notes from the backend (may be empty).
}

interface DiseasesResponse extends PageMeta {
  // Paginated list payload from GET `/diseases`.

  items: Disease[]
  // Page of diseases.
}

/**
 * Fetches a page of diseases (sick leaves) from the API.
 * Same cursor/limit contract as `fetchClients` / `fetchRules`.
 * @param cursor - Optional; pass `next_cursor` from a previous page for the next page.
 */
export async function fetchDiseases(cursor?: number): Promise<DiseasesResponse> {
  const { data } = await http.get<DiseasesResponse>('/diseases', {
    params: cursorParams(diseasesPageLimit, cursor),
  })
  if (import.meta.env.DEV) {
    console.log('[fetchDiseases] GET /diseases response', data)
  }
  return data
}
